import styled from 'styled-components';
import Button from 'src/components/core/button';
import { KIOSK_PRO_MEDIA } from 'src/components/kiosk-pro/kiosk-pro-shared/kiosk-pro-shared.styles';

export const PhoneNumberContainer = styled.div<{ $isInModal?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  gap: ${({ $isInModal }) => ($isInModal ? '56px' : '72px')};

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth}, ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    gap: ${({ $isInModal }) => ($isInModal ? '40px' : '56px')};
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    gap: ${({ $isInModal }) => ($isInModal ? '36px' : '48px')};
  }
`;

export const Title = styled.h1<{ $isInModal?: boolean }>`
  font-size: ${({ $isInModal }) => ($isInModal ? '36px' : '56px')};
  font-weight: 700;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: ${({ $isInModal }) => ($isInModal ? '28px' : '40px')};
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: ${({ $isInModal }) => ($isInModal ? '24px' : '36px')};
  }
`;

export const PhoneNumberPadWrapper = styled.div`
  margin: 0 auto;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    max-width: 256px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    max-width: 204px;
  }
`;

export const PhoneNumberPadGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    gap: 6px;
  }
`;

export const Number = styled.button`
  width: 112px;
  height: 112px;
  border: 2px solid ${({ theme }) => theme.customized.colors.buttonsLinks};
  background: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  margin: 0 auto;
  font-size: 36px;
  font-weight: bold;
  cursor: pointer;
  display: grid;
  place-items: center;
  svg {
    width: 27px;
    height: 27px;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    width: 80px;
    height: 80px;
    font-size: 28px;
    svg {
      width: 22px;
      height: 22px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    width: 64px;
    height: 64px;
    font-size: 24px;
    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const ZeroButton = styled(Number)`
  grid-column-start: 2;
`;

export const PhoneNumberInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const PhoneNumberDisplay = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const PhoneNumberText = styled.span<{ $isInModal?: boolean }>`
  font-size: ${({ $isInModal }) => ($isInModal ? '72px' : '112px')};
  font-weight: 700;
  white-space: pre;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: ${({ $isInModal }) => ($isInModal ? '56px' : '80px')};
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: ${({ $isInModal }) => ($isInModal ? '48px' : '64px')};
  }
`;

export const PhoneNumberPadContainer = styled.div<{ $isInModal?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 36px;

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth}, ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    gap: 28px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    gap: 24px;
  }
`;

export const ReadOnlyInput = styled.input`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0;
  margin: 0;
  border: 0;
  opacity: 0;
  cursor: text;
`;

export const BlinkingCursor = styled.span<{ $isInModal?: boolean }>`
  font-size: ${({ $isInModal }) => ($isInModal ? '72px' : '112px')};
  font-weight: bold;
  color: #000;
  animation: blink 1s infinite;
  pointer-events: none;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: ${({ $isInModal }) => ($isInModal ? '56px' : '80px')};
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: ${({ $isInModal }) => ($isInModal ? '48px' : '64px')};
  }

  @keyframes blink {
    0%,
    50% {
      opacity: 1;
    }
    51%,
    100% {
      opacity: 0;
    }
  }
`;

export const EnterButton = styled(Button)<{ $isInModal?: boolean }>`
  display: inline-block;
  padding: 36px 56px;
  font-weight: 700;
  font-size: 36px;
  width: 396px;
  height: 108px;
  border: none;
  background-color: ${({ theme }) => theme.customized.colors.buttonsLinks};
  color: ${({ theme }) => theme.colors.white};
  text-align: center;

  &:disabled {
    background-color: ${({ theme }) => theme.colors.blueGrey?.[80] ?? '#bccad2'};
    color: ${({ theme }) => theme.colors.white};
    cursor: not-allowed;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    font-size: 28px;
    padding: 28px 40px;
    width: 320px;
    height: 84px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: ${({ $isInModal }) => ($isInModal ? '24px' : '28px')};
    padding: ${({ $isInModal }) => ($isInModal ? '20px 36px' : '28px 40px')};
    width: 320px;
    height: 84px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: 24px;
    padding: 24px 36px;
    width: 232px;
    height: 72px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    font-size: 24px;
    padding: 24px 36px;
    width: ${({ $isInModal }) => ($isInModal ? '262px' : '280px')};
    height: 72px;
  }
`;
